import AxiosConfig from '@/config/axios-config'

export const CertificadoAPI = {

  emitirCertificados (arquivo) {
    let formData = new FormData()
    formData.append('arquivo', arquivo)

    return AxiosConfig.secureJalekoAPI().post('/solicitar-envio-certificados', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    }).then(response => response.data)
  }

}

export default CertificadoAPI
